import { useState, useEffect } from "react";
import MeuInput from "./meu_imput";
import ErrorControl from "./error_control.js";
import { ArrowRight } from "lucide-react";

import * as S from './styles';

import { writeStorage, useLocalStorage } from "@rehooks/local-storage";

function ClientPrompt({ updateClient, uuid, ip, showMsgErro, msgErro}) {
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [telefone, setTelefone] = useState("");
  const [storedTelefone] = useLocalStorage("telefone");
  const [storedNome] = useLocalStorage("nome");
  const [storedEmail] = useLocalStorage("email");

  const handleUpdateClient = () => {
    const cliente = {
      nome: nome,
      email: email,
      telefone: telefone,
      uuid: uuid,
      ip: ip,
    };
    if (nome.length > 0 && email.length > 0 && telefone.length > 0) {
      writeStorage("nome", nome);
      writeStorage("email", email);
      writeStorage("telefone", telefone);
    }
    updateClient(cliente);
  };

  useEffect(() => {
    if (!!storedNome) setNome(storedNome);
    if (!!storedEmail) setEmail(storedEmail);
    if (!!storedTelefone) setTelefone(storedTelefone);
  }, [storedNome, storedEmail, storedTelefone]);

  return (
    <S.BottomSheet>
      <S.DetailBox>
        <S.DestaquePlus>Olá!</S.DestaquePlus>
        <S.Texto1> Para sua segurança precisamos confirmar algumas informações.</S.Texto1>

        <MeuInput label="Seu nome" placeholder="Como deseja ser chamado" updateValue={setNome} value={storedNome} />
        <MeuInput label="Email" updateValue={setEmail} value={storedEmail} />
        <MeuInput label="Celular" isPhoneNumber={true} updateValue={setTelefone} value={storedTelefone} />
        <ErrorControl show={showMsgErro} error={msgErro} />
        <S.PrimaryButton
          onClick={handleUpdateClient}
          style={{
            fontSize: "28px",
            fontWeight: "bold",
          }}>
          Continuar <ArrowRight />
        </S.PrimaryButton>
      </S.DetailBox>
    </S.BottomSheet>
  );
}
export default ClientPrompt;
